"use strict";
window._theme = window._theme || {};
document.addEventListener('DOMContentLoaded', function() {
    _theme.initSlickSlider(jQuery('.notes-slider'),{
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 7,
    accessibility: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3
        }
      }
    ]
  });

});